var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-item",class:_vm.itemClass,attrs:{"data-name":_vm.name},on:{"click":_vm.changeTab}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }